import type { BulkActionAttr } from './types';

export const CREATE_FORMATS: BulkActionAttr[] = [
  {
    name: 'code',
    summary: 'プロジェクトコード',
    example: '123',
    required: true
  },
  {
    name: 'name',
    summary: 'プロジェクト名',
    example: '○○店',
    required: true
  },
  {
    name: 'disabled',
    summary: '状態',
    example: '無効：1\n有効：0',
    required: false
  },
  {
    name: 'allowance_target',
    summary: '日当対象',
    example: '日当対象：1\n日当対象外：0',
    required: false
  }
];
